__turbopack_context__.v({
  "clearButton": "searchInput-module-scss-module__wl6fya__clearButton",
  "inputWrapper": "searchInput-module-scss-module__wl6fya__inputWrapper",
  "searchIcon": "searchInput-module-scss-module__wl6fya__searchIcon",
  "searchInput": "searchInput-module-scss-module__wl6fya__searchInput",
});
